import { FIND_BIKE_REQUEST } from '../constants/find_bike.constants';

export const findBikeRequest = vrm => ({ type: FIND_BIKE_REQUEST, vrm });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/actions/find_bike.actions.js